// extracted by mini-css-extract-plugin
export default {"container":"type-icon_container__yClww","income":"type-icon_income__U-qRa","expense":"type-icon_expense__t77QI"};